module.exports = __webpack_public_path__ + "img/nuandong.7e51d5ce.jpg";